"use client";
import { usePathname } from "next/navigation";
import CustomCarousel from "@/components/CustomCarousel/CustomCarousel.js";
import "./doctorsCarousel.scss";
import Link from "next/link";
// import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import DoctorCardWithApi from "./DoctorCard/DoctorCardWithApi";
import { useIntl } from "react-intl";
import {useRouter, useSearchParams} from "next/navigation";
// import { fetchTopDoctors, selectAllTopDoctors } from "@/slice/topDoctorsSlice";

export default function DoctorsCarousel({ itemsPerPage, data }) {
  const pathname = usePathname();
  const router = useRouter();
  const searchParams = useSearchParams();
  const isHomePage = pathname === "/";
  const Urlcountry = searchParams.get("country") || "India";
  const [selectedCountry, setSelectedCountry] = useState(Urlcountry);
  // const dispatch = useDispatch();
  // const lang = useSelector((state) => state.locale.locale);
  // const doctors = useSelector(selectAllTopDoctors);
  const intl = useIntl();
  useEffect(() => {
    setSelectedCountry(Urlcountry);
  }, [Urlcountry]);

  const displayDoctors = data;

  return (
    <div className="doctorsCarouselWrapper">
      <div className="doctorsContainer">
        <div className="flex flex-col items-center text-center mb-8">
          <p className="doctorsHeading">
            {intl.formatMessage({ id: "findThe" })}{" "}
            <span className="highlight">
              {intl.formatMessage({ id: "topDoctors" })}
            </span>
          </p>
          {isHomePage && (
            <div className="mt-6 w-full max-w-md">
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
                <label className="font-roboto text-gray-600 text-lg whitespace-nowrap">
                  Select Your Country for Doctors
                </label>
                <select
                  value={selectedCountry}
                  onChange={(e) =>{
                    const country = e.target.value;
                    setSelectedCountry(country);
                    const params = new URLSearchParams(searchParams.toString());
                    params.set("country", country);
                    router.replace(`${pathname}?${params.toString()}`, { scroll: false });
                  }}
                  className="font-roboto px-4 py-2 rounded-lg border border-gray-200 bg-white text-gray-800 w-full sm:w-auto min-w-[200px] focus:outline-none focus:ring-2 focus:ring-blue-500 appearance-none cursor-pointer"
                  style={{
                    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E")`,
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right 1rem center",
                    backgroundSize: "1.5em 1.5em",
                    paddingRight: "2.5rem",
                  }}
                >
                  <option value="India">India</option>
                  <option value="Thailand">Thailand</option>
                  <option value="Turkey">Turkey</option>
                  <option value="USA">USA</option>
                  <option value="UAE">UAE</option>
                  <option value="South Korea">South Korea</option>
                  <option value="Malaysia">Malaysia</option>
                  <option value="Germaney">Germaney</option>
                  <option value="UK">UK</option>
                </select>
              </div>
            </div>
          )}
        </div>

        {displayDoctors?.data?.length > 0 && (
          <CustomCarousel itemsPerPage={itemsPerPage}>
            {displayDoctors.data.map((doctor, i) => (
              <DoctorCardWithApi key={doctor.id || i} doctor={doctor} />
            ))}
          </CustomCarousel>
        )}

        <Link href="/doctors" className="viewMoreBtn">
          {intl.formatMessage({ id: "viewAllDoctors" })}
        </Link>
      </div>
    </div>
  );
}
